import { abyssColors } from '@/theme/colors';

export const titleStyle = {
  fontWeight: 700,
  color: abyssColors.primary[500],
  textTransform: 'none',
};

export const accordionStyle = {
  mb: 2,
  boxShadow: 'none',
  '&:before': { display: 'none' },
  borderRadius: '0.8rem',
  '&::before': {
    display: 'none',
  },
  '&.MuiAccordion-root::before': {
    display: 'none',
  },
  '& .MuiAccordionSummary-content': {
    margin: '0px !important',
  },
  '& .MuiAccordionSummary-root': {
    padding: '1.6rem 0.8rem',
    gap: '0.8rem',
    minHeight: 'fit-content',
  },
  '& .MuiAccordionDetails-root': {
    border: `0.1rem solid ${abyssColors.primary[100]}`,
    borderRadius: '0 0 0.8rem 0.8rem',
    borderTop: 0,
  },
};

export const accordionSummaryStyle = {
  backgroundColor: abyssColors.primary[50],
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper': {
    transform: 'rotate(-90deg)',
    transition: 'transform 0.2s ease-in-out',
    '&.Mui-expanded': {
      transform: 'rotate(0deg)',
    },
  },
  '& .MuiSvgIcon-root': {
    color: abyssColors.primary[500],
  },
};
